<template >
    <!-- 引导app行动面板-->
    <van-action-sheet v-model:show="show">
        <div class="app-sheet-header">
            <img src="@/assets/images/live/playing/sheet_close.png" class="close" @click="show = false">
        </div>
        <div class="app-sheet-content">
            <p class="text">{{ text }}</p>
            <OpenApp :unitKey="unitKey" :options="options">
                <van-button round type="primary" class="button" @click="clickButton">打开{{ brandName }}APP</van-button>
            </OpenApp>
        </div>
    </van-action-sheet>
</template>
<script>
import OpenApp from '../OpenApp.vue'
import { getCurrentBrand } from '@/config/brand';
export default {
    props: {
        text: String,
        unitKey: {
            type: String,
            default: ""
        },
        options: {
            type: Object,
            default: {}
        },
    },
    data() {
        return {
            show: false,
            buttonDisabled: false,
            brandName: ''
        };
    },
    methods: {
        clickZan() {
            this.$emit("onZan");
        },
        clickCat() {
            this.$emit("onCar");
        },
        showAppSheet() {
            this.show = true;
        },
        clickButton() {
            this.$emit("onButton");
        }
    },
    mounted() {
        this.currentBrandColor = this.getCurrentBrandColor();
        this.brandName = getCurrentBrand.name
    },
    components: { OpenApp }
}
</script>
<style lang="scss" scoped>
/deep/ .van-overlay {
    background-color: rgba(0, 0, 0, .05);

}

.van-overlay {
    background-color: rgba(0, 0, 0, .05);
}

.van-popup--bottom.van-popup--round {
    border-radius: 8px 8px 0px 0px;
}

.app-sheet {
    &-header {
        padding: .32rem .21rem;
        text-align: right;

        .close {
            width: 0.32rem;
        }
    }

    &-content {
        padding-top: .93rem;
        padding-bottom: 1.47rem;
        text-align: center;

        .text {
            font-size: 0.37rem;
            color: #666666;
            margin-bottom: .8rem;
        }


    }


}

.button {
    @include margin_center;
    width: 6.59rem;
    text-align: center;
}

// .app-sheet {
//     &-mask {
//         background-color: rgba(0, 0, 0, .05);
//     }
// }
</style>